import { store } from '../../../../../app/store'
import { getUnique } from '../../../../helpers/common'
import { PANEL_FINANCE_BY_DYNAMIC_KEY } from '../../../../portfolioInsights/finance/body/config'
import TableComponent from '../../../../portfolioInsights/finance/body/panelContainer/table/TableComponent'
import {
  resetData,
  selectCompareLeft,
  selectCompareRight,
} from '../../../../portfolioInsights/finance/store/slice'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
} from '../../constant'
import ItemSelectPortfolio, {
  Title,
} from '../../preferenceSetting/detailTemplate/settingPanel/information/ItemSelectPortfolio'

const { NODE } = TYPE_INFORMATION_PANEL

export const COMPARE_LEFT = '1'
export const COMPARE_RIGHT = '2'

export const PANELS = {
  LIQUIDITY_SOLVENCY_AND_COVERAGE: 'liquiditySolvencyAndCoverage',
  ASSET_MANAGEMENT_EFFICIENCY: 'assetManagementEfficiency',
  PROFITABILITY: 'profitability',
  BUSINESS_GROWTH_CORP: 'businessGrowthCorporate',
  CAPITAL_ADEQUACY: 'capitalAdequacy',
  ASSET_QUALITY: 'assetQuality',
  EARNINGS_QUALITY: 'earningsQuality',
  FUNDING_AND_LIQUIDITY_BANK: 'fundingAndLiquidityBank',
  BUSINESS_GROWTH_BANK: 'businessGrowthBank',
  BUSINESS_POSITION: 'businessPosition',
  CAPITAL_EARNING_AND_LEVERAGE: 'capitalEarningAndLeverage',
  FUNDING_AND_LIQUIDITY_SEC: 'fundingAndLiquiditySecurity',
}

export const getPanelListFinance = () => {
  return [
    {
      label: 'dynamicReport.FINANCE',
      children: [
        {
          label: 'dynamicReport.CORPORATE',
          children: [
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.LIQUIDITY_SOLVENCY_AND_COVERAGE,
              label: 'dynamicReport.LIQUIDITY_SOLVENCY_AND_COVERAGE',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: [
                  'RT0020',
                  'RT0019',
                  'RT0018',
                  'RT0033',
                  'RT0027',
                  'RT0037',
                  'RT0047',
                  'RT0044',
                  'RT0046',
                  'RT0045',
                ],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.ASSET_MANAGEMENT_EFFICIENCY,
              label: 'dynamicReport.ASSET_MANAGEMENT_EFFICIENCY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: [
                  'RT0009',
                  'RT0011',
                  'RT0013',
                  'RT0015',
                  'RT0003',
                  'RT0006',
                ],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.PROFITABILITY,
              label: 'dynamicReport.PROFITABILITY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: [
                  'RT0050',
                  'RT0348',
                  'RT0054',
                  'RT0052',
                  'RT0051',
                  'RT0060',
                  'RT0059',
                ],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.BUSINESS_GROWTH_CORP,
              label: 'dynamicReport.BUSINESS_GROWTH',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: [
                  'RT0156',
                  'RT0161',
                  'RT0159',
                  'RT0387',
                  'RT0172',
                  'RT0174',
                ],
              },
            },
          ],
        },
        {
          label: 'dynamicReport.BANK',
          children: [
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.CAPITAL_ADEQUACY,
              label: 'dynamicReport.CAPITAL_ADEQUACY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['RT0249', 'NB219', 'RT0248'],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.ASSET_QUALITY,
              label: 'dynamicReport.ASSET_QUALITY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['RT0266', 'RT0237', 'RT0238', 'RT0236'],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.EARNINGS_QUALITY,
              label: 'dynamicReport.EARNINGS_QUALITY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['RT0285', 'RT0252', 'RT0060', 'RT0059'],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.FUNDING_AND_LIQUIDITY_BANK,
              label: 'dynamicReport.FUNDING_AND_LIQUIDITY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['RT0277', 'LATL', 'RT0287'],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.BUSINESS_GROWTH_BANK,
              label: 'dynamicReport.BUSINESS_GROWTH',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['RT0173', 'RT0172', 'RT0296', 'RT0161'],
              },
            },
          ],
        },
        {
          label: 'dynamicReport.SECURITY',
          children: [
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.BUSINESS_POSITION,
              label: 'dynamicReport.BUSINESS_POSITION',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['SABBMS', 'OSBMS'],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.CAPITAL_EARNING_AND_LEVERAGE,
              label: 'dynamicReport.CAPITAL_EARNING_AND_LEVERAGE',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['RT0060', 'RT0059', 'RT0034', 'CIR', 'LTE'],
              },
            },
            {
              screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE,
              panel: PANELS.FUNDING_AND_LIQUIDITY_SEC,
              label: 'dynamicReport.FUNDING_AND_LIQUIDITY',
              type: TYPE_ITEM_SETTING.PANEL,
              setting: {
                [COMPARE_LEFT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                [COMPARE_RIGHT]: {
                  isChecked: false,
                  selectValue: undefined,
                },
                ratios: ['STF', 'LTF', 'LTFLA', 'LASTF'],
              },
            },
          ],
        },
      ],
    },
  ]
}

export const getPanelPortfolioByFinance = (panelKey, setting) => {
  const { callApi, companyType, ratiosSelected } =
    PANEL_FINANCE_BY_DYNAMIC_KEY[panelKey]
  const typePrefix = callApi.typePrefix
  const {
    [COMPARE_LEFT]: leftSetting,
    [COMPARE_RIGHT]: rightSetting,
    ratios,
  } = setting
  const otherParam = {
    portfolioId1: leftSetting?.isChecked ? leftSetting?.selectValue : undefined,
    portfolioId2: rightSetting?.isChecked
      ? rightSetting?.selectValue
      : undefined,
  }

  return {
    renderComponent: () => (
      <TableComponent typePrefix={typePrefix} isDynamicReport={true} />
    ),
    thunk: [
      ({ portfolioParams }) =>
        callApi({
          ...portfolioParams,
          ...otherParam,
          companyType,
          ratiosSelected: ratios,
        }),
    ],
    isWaitForMount: true,
    isTable: true,
    return: (dispatch) => dispatch(resetData(typePrefix)),
    settingPanel: {
      items: [
        {
          type: NODE,
          renderItem: () => <Title value={'dynamicReport.COMPARE_WITH'} />,
        },
        {
          type: NODE,
          renderItem: ({ key, ...other }) => (
            <ItemSelectPortfolio keySetting={COMPARE_LEFT} {...other} />
          ),
        },

        {
          type: NODE,
          renderItem: ({ key, ...other }) => (
            <ItemSelectPortfolio keySetting={COMPARE_RIGHT} {...other} />
          ),
        },
        {
          type: NODE,
          renderItem: () => <Title value={'dynamicReport.SELECT_INDICATOR'} />,
        },
        ...getRatioList(ratiosSelected, companyType),
      ],
    },
  }
}

export const getDefaultFinance = () => {
  const compareLeft = selectCompareLeft(store.getState())
  const compareRight = selectCompareRight(store.getState())

  const result = []
  const [finance] = getPanelListFinance()

  finance.children.forEach((displayType) => {
    displayType.children.forEach((indicator) => {
      result.push({
        ...indicator,
        id: getUnique(),
        setting: {
          ...indicator.setting,
          [COMPARE_LEFT]: {
            isChecked: !!compareLeft,
            selectValue: compareLeft,
          },
          [COMPARE_RIGHT]: {
            isChecked: !!compareRight,
            selectValue: compareRight,
          },
        },
      })
    })
  })

  return result
}

const getRatioList = (ratios, companyType) => {
  return ratios.map((ratio) => ({
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    key: 'ratios',
    value: ratio,
    title: `portfolio.finance.${companyType}_${ratio}`,
    style: { marginLeft: 20 },
  }))
}
